// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MassEditModal_wrapper__mAa87","alert":"MassEditModal_alert__vMud1"};